const styles = theme => ({
  container: {
    display: 'flex',
  },
  field: {
    marginBottom: theme.spacing(1),
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '66%',
      padding: theme.spacing(2),
      marginRight: theme.spacing(2),
      justifyContent: 'space-between',
    },
  },
  summary: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      width: '34%',
    },
  },
  title: {
    marginBottom: theme.spacing(3),
  },
  linkCancelLogin: {
    marginTop: theme.spacing(1),
  },
})

export default styles
